var SCAAFFCustomerReferSetting = {
    "program": {
        "active": false,
        "shop": "kakao-mischa.myshopify.com",
        "incentive": {
            "type": "percentage",
            "value": "5.00",
            "price_rule_id": "",
            "coupon": ""
        },
        "program": "NzI2NzI="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Herzensmenschen einladen",
            "refer_background_color": "#641418",
            "refer_text_color": "#ffffff",
            "web_position": "left-bottom",
            "mobile_position": "left-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "Teile dein Gl\u00fcck und lass dich mit kakao belohnen",
            "popup_description": "Schenke deinen Herzensmenschen 5% Rabatt in unserem Shop und erhalte 10% ihrer Bestellung bei uns gutgeschrieben! Erstelle deinen pers\u00f6nlichen Link und teile ihn mit deinen Liebsten. :)",
            "button_text_get_invite": "Und los!",
            "button_copy_invite": "Kopieren",
            "popup_background_color": "#641418",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "5% Rabatt f\u00fcr dich",
            "shop_description": "Gl\u00fcckwunsch! Ein gro\u00dfes Herz hat dir satte 5% Rabatt auf deinen Einkauf bei uns beschert. Diese werden am Schluss automatisch auf deine Bestellung angewandt. Enjoy!",
            "shop_button_text": "Weiter zum Shop",
            "shop_background_color": "#641418",
            "shop_text_color": "#ffffff"
        }
    }
}

function waitForCustomerReferralLoaded(a, b = 100) {
  const c = setInterval(function () {
    "undefined" != typeof uppromoteCustomerReferral && (a(), clearInterval(c));
  }, b);
  setTimeout(function () {
    clearInterval(c);
  }, 5e3);
}
function waitElementLoaded(a, b, c = 100) {
  const d = setInterval(function () {
    const c = document.querySelector(a);
    c && (b(), clearInterval(d));
  }, c);
  setTimeout(function () {
    clearInterval(d);
  }, 5e3);
}

waitElementLoaded(`.sca_aff_customer_refer_shop_now_button`, function () {
  waitForCustomerReferralLoaded(function () {
    document.querySelectorAll('a.sca_aff_customer_refer_shop_now_button')[0].href = 'https://kakaomischa.de/products/zeremonieller-kakaotaler-mit-anleitung-affirmation-im-flyer-geschenk-bundle';
    document.querySelectorAll('a.sca_aff_customer_refer_shop_now_button')[0].target = '_blank';
  });
});